import type { ClientRuntimeSettings } from "@/models";
import type { UseQueryOptions } from "@tanstack/react-query";
import { axios } from "@/api/axios";

export const getRuntimeSettings = async (): Promise<ClientRuntimeSettings> => {
  try {
    const response = await axios.get<ClientRuntimeSettings>("/runtimeSettings");
    return response.data;
  } catch (error) {
    console.error("Error fetching runtime settings:", error);
    throw error;
  }
};

export const getRuntimeSettingsQuery =
  (): UseQueryOptions<ClientRuntimeSettings> => ({
    queryKey: ["runtimeSettings"],
    queryFn: () => getRuntimeSettings(),
    staleTime: 1000 * 60 * 60 // 1 hour
  });
